import React, { useState } from 'react'
import { Box, Breadcrumbs, Link, Paper, Typography, Button, LinearProgress, linearProgressClasses, CircularProgress, CircularProgressProps, circularProgressClasses, Card, Container, TooltipProps, tooltipClasses, Tooltip, FormGroup, Stack, Switch } from '@mui/material';
import Grid from '@mui/material/Grid2';
import styled from '@emotion/styled';
import { communication, file, hubspot, humanResource, personAdd, salesForceImg, girlWithLaptop, mostPopular } from '../../assets/images';
import { GroupIcon, LaunchIcon, PauseIcon, PlayIcon, CommunicationIcon, DatabaseIcon, InformationIcon } from '../../assets/icons';
import CancelAccountModal from '../../modals/CancelAccount';


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 18,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: "#DDE0E5",
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 16,
        backgroundColor: '#614EFA',
    },
}));

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: "#2B2B30",
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: "#2B2B30",
    },
}));

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(18px)',
            top: "2px"
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        top: "2px",
        left: "2px",
        '&.Mui-checked': {
            transform: 'translateX(17px)',
            color: '#fff',
            top: "2px",
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#614EFA',
                // ...theme.applyStyles('dark', {
                //     backgroundColor: '#177ddc',
                // }),
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 18,
        height: 18,
        borderRadius: 18,
        transition: "200ms ease all",
    },
    '& .MuiSwitch-track': {
        borderRadius: 18,
        opacity: 1,
        backgroundColor: '#614EFA',
        boxSizing: 'border-box',
        // ...theme.applyStyles('dark', {
        //     backgroundColor: 'rgba(255,255,255,.35)',
        // }),
    },
}));

const SubscriptionDetailsEasyCRM = ({ navigate }: any) => {
    function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    const [renewelPaused, setRenewelPaused] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);


    const handleOpen = () => {
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false);
    };


    return (
        <Container sx={{ maxWidth: "1500px !important", px: '0!important' }}>
            <div role="presentation" onClick={handleClick}>
                <Breadcrumbs aria-label="subsciption details breadcrumb" sx={{
                    color: "#614EFA", fontSize: "14px", paddingTop: "0 !important", "& li:last-child a": { color: "#000000" }
                }}>
                    <Link underline="hover" color="#614EFA" href="/" onClick={() => {
                        navigate('/subscription');
                    }}>
                        Subscriptions
                    </Link>
                    <Link
                        underline="hover"
                        href="#"
                    >
                        EasyCRM
                    </Link>
                </Breadcrumbs>
            </div>
            <Box mt={"18px"} display={"flex"} alignItems={"center"}>
                <Typography variant="h2" color="initial" display={"inline"} fontSize={"34px"} fontWeight={"500"}>Growth Plan</Typography><Box display={"inline-flex"} width={"fit-content"} p={"3px 12px"} borderRadius={"10px"} bgcolor={"rgba(97, 78, 250, 0.10)"} color={"#614EFA"} ml={3} fontSize={"16px"} fontWeight={"500"}>Active</Box>
            </Box>

            <Paper sx={{
                p: "24px", mt: "39px", borderRadius: "8px",
                border: "1px solid #E8EAF0", boxShadow: "none"
            }}>
                <Box display={"flex"} justifyContent={"space-between"} flexWrap={"wrap"} gap={"16px"}>
                    <Box>
                        <Typography variant="body2" color="#333333">Plan Details</Typography>
                        <Typography variant="h5" color="initial" fontWeight={"500"} mt={1}>Growth Plan</Typography>
                    </Box>
                    <Button sx={{
                        textTransform: 'capitalize', color: '#FFFFFF !important', px: '24px', height: '40px', borderRadius: '8px', '&:hover': {
                            border: 'none', boxShadow: 'none !important'
                        },
                    }}>Upgrade Plan</Button>
                </Box>
                <Box display={"flex"} mt="32px" flexWrap={"wrap"}>
                    <Box minWidth={"184px"} width={"17%"} margin={{ xs: "0 0 24px", sm: "" }}>
                        <Typography variant="body2" color="#333333">Start Date</Typography>
                        <Typography variant="h6" color="initial" fontWeight={"500"} mt={1}>11 Oct, 2024</Typography>
                    </Box>
                    <Box minWidth={"184px"} width={"17%"} margin={{ xs: "0 0 24px", sm: "" }}>
                        <Typography variant="body2" color="#333333">Next Billing Date</Typography>
                        <Typography variant="h6" color="initial" fontWeight={"500"} mt={1}>12 Nov 2024</Typography>
                    </Box>
                    <Box minWidth={"184px"} width={"17%"} margin={{ xs: "0 0 24px", sm: "" }}>
                        <Typography variant="body2" color="#333333">Next Billing Amount</Typography>
                        <Typography variant="subtitle1" color="initial" fontSize={"18px"} fontWeight={"500"} mt={1}>$220</Typography>
                    </Box>
                </Box>
            </Paper>
            <Paper sx={{
                p: "24px", mt: "39px", borderRadius: "8px",
                border: "1px solid #E8EAF0", boxShadow: "none"
            }}>
                <Typography variant="h5" color="initial" fontWeight={"500"} mb={1} > Plan Usage</Typography>
                <Box flexWrap={"wrap"}>
                    <Grid container columnSpacing={{ xs: 3, sm: 4, md: 4, lg: 4 }}>
                        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }} display={"flex"} alignItems={"center"} pb={{ xs: "32px", md: "48px" }} pt={{ xs: "24px", md: "48px" }}>
                            <Box width={"100%"}>
                                <Box display={"flex"} justifyContent={"space-between"}><Typography color='#333333' fontSize='12px' mb='4px' textAlign='left'>Users</Typography><Typography color='#333333' fontSize='12px' mb='6px' textAlign='left'>5 Users</Typography></Box>
                                <BorderLinearProgress variant="determinate" value={70} />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 4 }} display={"flex"} alignItems={"center"} pb={{ xs: "42px", md: "48px" }} pt={{ xs: "24px", md: "48px" }}>
                            <Box width={"100%"}>
                                <Box display={"flex"} justifyContent={"space-between"}><Typography color='#333333' fontSize='12px' mb='4px' textAlign='left'>Calling Credits</Typography><Typography color='#333333' fontSize='12px' mb='6px' textAlign='left'>$2 of $5/ User</Typography></Box>
                                <BorderLinearProgress variant="determinate" value={70} />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 10, lg: 4, xl: 4 }}>
                            <Box className="storage-box-con" p={{ sx: "0 0 20px", xl: "0 20px 20px" }} display={"flex"} alignItems="end" justifyContent="center">
                                <Box className="storage-box" sx={{ position: 'relative' }} height={"100%"} maxHeight="142px" width={"100%"} maxWidth={"142px"} mr="36px">
                                    <CircularProgress variant="determinate" value={25} size={"100%"} color='primary' sx={(theme) => ({
                                        color: '#614EFA',
                                        animationDuration: '550ms',
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        zIndex: 1,
                                        [`& .${circularProgressClasses.circle}`]: {
                                            strokeLinecap: 'round',
                                            color: "#614EFA",
                                        },
                                        ...theme.applyStyles('dark', {
                                            color: '#308fe8',
                                        }),
                                    })} />
                                    <CircularProgress variant="determinate" value={100} size={"100%"} color='primary' sx={(theme) => ({
                                        color: '#E8E8EA',
                                        animationDuration: '550ms',
                                        position: 'absolute',
                                        left: 0,
                                        top: 0,
                                        [`& .${circularProgressClasses.circle}`]: {
                                            strokeLinecap: 'round',
                                            color: "#E8E8EA",
                                        },
                                        ...theme.applyStyles('dark', {
                                            color: '#E8E8EA',
                                        }),
                                    })} />
                                    <Box
                                        sx={{
                                            top: 0,
                                            left: 0,
                                            bottom: 0,
                                            right: 0,
                                            position: 'absolute',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',

                                        }}
                                    >
                                        <Typography
                                            variant="caption"
                                            component="div"
                                            sx={{
                                                color: '#333333',
                                                fontSize: '18px',
                                                fontWeight: "500"
                                            }}
                                        >32% Used</Typography>
                                    </Box>
                                </Box>
                                <Box>
                                    <Typography variant="h5" color="#000000" fontWeight={"500"} mb={"21px"} >Storage</Typography>
                                    <Box display={"flex"} alignItems="center" mb={2}>
                                        <Box className="small-cirle" bgcolor={"#E8E8EA"} borderRadius={"100%"} height={"15px"} width={"15px"} mr={2}></Box>
                                        <Typography variant="subtitle1" color="#000000" fontSize={{ sm: "14px", md: "16px" }}>50GB Total</Typography>
                                    </Box>
                                    <Box display={"flex"} alignItems="center">
                                        <Box className="small-cirle" bgcolor={"#614EFA"} borderRadius={"100%"} height={"15px"} width={"15px"} mr={2}></Box>
                                        <Typography variant="subtitle1" color="#000000" >25 GB Used</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Paper >

            {/* ==================pricing table ================= */}
            <Box className="container ew-plan-boxes-con crm-plan-boxes" mt="42px">
                <Box display="flex" justifyContent="space-between" width="100%" flexWrap="wrap" mb={3} gap={2}>
                    <Typography variant="h5" color="initial" fontWeight={"500"} >Upgrade Plan</Typography>
                    <FormGroup>
                        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                            <Typography color='#614EFA' fontWeight="500">Monthly</Typography>
                            <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} />
                            <Typography display="flex" alignItems="center" gap={1}>Annual <Typography component="span" color="#2B2B30" fontSize="12px">(2 Months Free)</Typography></Typography>
                        </Stack>
                    </FormGroup>
                </Box>
                <div className="ew-four-plans">
                    <div className="box">
                        <div>
                            <h3>Start Up</h3>
                            <div className="ew-price-info price-info-monthly ew-show">
                                <Typography component="p" color='#614EFA'>$9.99</Typography>
                                <Typography component="span" mt="2px">
                                    <span>Billed Monthly</span>
                                </Typography>
                            </div>
                            <button
                                className="buy-monthly pro-btn ew-show standard-btn"
                                onClick={() => console.log("Monthly plan selected")}
                            >
                                Downgrade
                            </button>
                            <Box className="ew-features-listing" mb="100px">
                                <h4>Features</h4>
                                <ul>
                                    <li>1 User</li>
                                    <li>10 GB Storage</li>
                                    <li>No Calling Credits</li>
                                </ul>
                            </Box>
                        </div>
                        <a href="#tbl_scrollable">
                            <div className="footer-sec">
                            </div>
                        </a>
                    </div>


                    {/* <!-- remove this className (black-friday-sales-className) when blackfriday changes are removed --> */}
                    <div className="box">
                        <div>
                            <h3>
                                Growth Plan
                            </h3>
                            <div className="ew-price-info price-info-monthly ew-show">
                                <Typography component="p" color='#614EFA'>$14.99</Typography>
                                <Typography component="span" mt="2px">
                                    <span>Billed Monthly</span>
                                </Typography>
                            </div>
                            <button
                                className="pro-btn pro-btn-bg buy-monthly ew-show active"
                                onClick={() => console.log("Monthly Plan Selected")}
                            >
                                Active
                            </button>

                            <Box className="ew-features-listing" mb="100px">
                                <h4>Features</h4>
                                <ul>
                                    <li>5 Users</li>
                                    <li>50 GB Storage</li>
                                    <li>$5/User calling Credits</li>
                                </ul>
                            </Box>
                        </div>
                        <a href="#tbl_scrollable">
                            <div className="footer-sec">
                            </div>
                        </a>
                    </div>

                    <div className="box">
                        <div>
                            <h3>
                                Scale Plan
                            </h3>
                            <div className="ew-price-info price-info-monthly ew-show">
                                <Typography component="p" color='#614EFA'>$99</Typography>
                                <Typography component="span" mt="2px">
                                    <span>Billed Monthly</span>
                                </Typography>
                            </div>
                            <button
                                className="pro-btn pro-btn-bg buy-monthly ew-show"
                                onClick={() => console.log("Monthly Plan Selected")}
                            >
                                Upgrade
                            </button>

                            <Box className="ew-features-listing" mb="100px">
                                <h4>Features</h4>
                                <ul>
                                    <li>1 User</li>
                                    <li>10 GB Storage</li>
                                    <li>$10/User calling Credits</li>
                                </ul>
                            </Box>
                        </div>
                        <a href="#tbl_scrollable">
                            <div className="footer-sec">
                            </div>
                        </a>
                    </div>
                </div>
            </Box>
            {/* ==================pricing table ================= */}

        </Container >
    )
}

export default SubscriptionDetailsEasyCRM